export const environment = {
  production: false,
  apiUrl: "https://api.zatlive.com/api/",
  // apiUrl: "http://127.0.0.1:5000/api/",
  STRIPE_API_KEY:
    "pk_test_51Oo6xCCATFoGGCiAdiLFhPbazx00lecg4ZKGrws1rwAc1uvqBRZxZwO71NLhMceZDr1xziJSHtCqMRchNb8QFPCb00nYrBEG71",
};
